(() => {
 const init = (root = document) => root.querySelectorAll('[data-sedy-header]').forEach(header => {
  if(header.dataset.ready) return;
  header.dataset.ready = 'true';
  const section = header.closest('.cc-header');
  const toggle = header.querySelector('.shv-mobile-toggle');
  const dialog = header.querySelector('.shv-drawer');
  const dropdowns = [...header.querySelectorAll('.shv-dropdown')];
  let previousOverflow = '', last = scrollY, scheduled = false;
  const closeMenus = () => dropdowns.forEach(d => d.open = false);
  const closeDrawer = () => dialog.close();
  toggle.addEventListener('click', () => {
   closeMenus(); previousOverflow = document.body.style.overflow;
   dialog.showModal(); document.body.style.overflow = 'hidden';
   toggle.setAttribute('aria-expanded','true');dialog.querySelector('.shv-close').focus();
  });
  dialog.querySelector('.shv-close').addEventListener('click',closeDrawer);
  dialog.addEventListener('close', () => {document.body.style.overflow = previousOverflow;toggle.setAttribute('aria-expanded','false');toggle.focus({preventScroll:true});});
  dialog.addEventListener('click', e => {if(e.target === dialog && e.clientX > dialog.getBoundingClientRect().right) closeDrawer();});
  dropdowns.forEach(d => {
   d.addEventListener('toggle', () => {if(d.open) dropdowns.filter(x=>x!==d).forEach(x=>x.open=false);});
   d.addEventListener('keydown', e => {if(e.key==='Escape'){e.preventDefault();d.open=false;d.querySelector('summary').focus();}});
   d.addEventListener('focusout', () => setTimeout(()=>{if(!d.contains(document.activeElement))d.open=false;},0));
  });
  const outside = e => {if(!e.target.closest('.shv-dropdown'))closeMenus();};
  document.addEventListener('click',outside);
  function geometry(){
   if(!header.isConnected)return;
   const height=header.offsetHeight,end=Math.max(0,header.getBoundingClientRect().bottom);
   document.documentElement.style.setProperty('--header-height',height+'px');
   document.documentElement.style.setProperty('--header-end',end+'px');
   document.documentElement.style.setProperty('--header-end-padded',(end+20)+'px');
   document.documentElement.style.setProperty('--content-start',height+'px');
  }
  const onScroll=()=>{
   if(scheduled)return;scheduled=true;
   requestAnimationFrame(()=>{
    const current=scrollY;
    const locked=dialog.open||dropdowns.some(d=>d.open)||header.contains(document.activeElement)||document.body.classList.contains('fixed');
    if(innerWidth<1100 && current>220 && !locked){
     if(current>last+4)section.classList.add('shv-hidden');
     else if(current<last-4)section.classList.remove('shv-hidden');
    }else section.classList.remove('shv-hidden');
    last=current;geometry();scheduled=false;
   });
  };
  const onResize=()=>{if(innerWidth>=1100&&dialog.open)closeDrawer();section.classList.remove('shv-hidden');geometry();};
  window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onResize);
  const observer=new ResizeObserver(geometry);observer.observe(header);geometry();
  header.addEventListener('focusin',()=>section.classList.remove('shv-hidden'));
  const unload=e=>{if(e.target.contains(header)){observer.disconnect();document.removeEventListener('click',outside);window.removeEventListener('scroll',onScroll);window.removeEventListener('resize',onResize);document.removeEventListener('shopify:section:unload',unload);if(dialog.open)document.body.style.overflow=previousOverflow;}};
  document.addEventListener('shopify:section:unload',unload);
 });
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
